"use client";

/**
 * NewForm design-system Input.
 *
 * Plain HTML `<input>` styled with DS tokens — Rethink Sans 14px,
 * `rounded-nf-ds-md`, brand-purple focus ring, white surface. Mirrors
 * the legacy shadcn Input surface so call sites can swap imports
 * incrementally:
 *
 *   import { Input } from "@/components/ui/design-system/input";
 *
 *   <Input value={value} onChange={(e) => setValue(e.target.value)} />
 */

import * as React from "react";

import { cn } from "@/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        ref={ref}
        className={cn(
          "flex h-10 w-full rounded-nf-ds-md border border-input bg-white px-nf-ds-3 font-nf-ds-sans text-[14px] text-foreground placeholder:text-muted-foreground transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-nf-ds-purple-product/40 focus-visible:ring-offset-1 focus-visible:border-nf-ds-purple-product/60 disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
